@if (error() && !isLoading()) {
  <nk-error-alert [error]="error()!"></nk-error-alert>
}

@if (isLoading()) {
  <nk-progress [isLoading]="true"></nk-progress>
}

@if (items$ | async; as items) {
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-3 gap-2">
    <h2 class="mb-0">{{ 'screening.case.review.case_review_title' | translate }}</h2>
    @if (items.length > 0) {
      <nk-screening-case-review-progress class="flex-shrink-0" [items]="items"></nk-screening-case-review-progress>
    }
  </div>
  @if (items.length === 0) {
    <div class="alert alert-info">{{ 'screening.entity_screening_cases.no_cases' | translate }}</div>
  } @else {
    @if (screeningCaseReviewStatusList$ | async; as statusList) {
      <accordion [isAnimated]="true">
        @for (item of items; track item.uuid) {
          <accordion-group [isOpen]="openPanels()[item.uuid]" (isOpenChange)="onPanelToggle(item.uuid, $event)">
            <div
              accordion-heading
              class="d-flex justify-content-between align-items-center"
              [class.bg-light-blue-contrast]="item.latestReviewStatusKey === reviewStatusComplete">
              <div>
                @if (item.latestReviewStatusKey === reviewStatusComplete) {
                  <i
                    class="fa fa-check-circle me-2"
                    [tooltip]="'screening.case.comparison.review_status_complete_tooltip' | translate"></i>
                }
                {{ item.title }}
                @if (item.matchScore !== null) {
                  <span
                    class="tag tag-light-blue ms-2 me-2"
                    [tooltip]="'screening.case.comparison.match_score_tooltip' | translate"
                    >{{ item.matchScore }}</span
                  >
                }
                -
                <span [class.text-muted]="item.latestReviewStatusKey !== reviewStatusComplete">
                  {{ item.data.screening_case.created_timestamp | date: dateFormats.DateAndTime }}
                </span>
              </div>
              <div class="d-inline-block">
                @if (item.latestReviewComment) {
                  <span [class.text-muted]="item.latestReviewStatusKey !== reviewStatusComplete" class="me-2">
                    {{ 'screening.case.forms.comment.title' | translate }}: {{ item.latestReviewComment }}
                  </span>
                }
                <nk-screening-case-card-status-list-item
                  [entity]="item"
                  [prop]="'screeningStatusTags'"></nk-screening-case-card-status-list-item>
                @if (!printView()) {
                  <nk-caret-expander class="ms-2" [isExpanded]="openPanels()[item.uuid]"></nk-caret-expander>
                }
              </div>
            </div>
            <nk-screening-case-comparison
              [screeningCaseComposite]="item.data"
              [person]="item.person"
              [customerPerson]="item.customerPerson"
              [company]="item.company"
              [companyDetails]="item.companyDetails"
              [companyLocations]="item.companyLocations"
              [screeningConfigUuid]="screeningConfigUuid()"
              [screeningCaseReviewStatusList]="statusList"
              [printView]="printView()"
              (reviewSaved)="onReviewSaved()"
              (reviewCreated)="onReviewCreated()"></nk-screening-case-comparison>
          </accordion-group>
        }
      </accordion>
    }
    <nk-screening-adverse-media-card-list
      [screeningEntityUuid]="screeningEntityUuid()"></nk-screening-adverse-media-card-list>
  }
}
